import api from "./ApiURLBase";
const EndPointSalidasVehiculosId = async id =>
  await api.get(`/tempyards/GetVehicles/${id}`);
const EndPointSalidasStatus = async () =>
  await api.get(`/tempyards/GetOutputStates`);
export { EndPointSalidasVehiculosId, EndPointSalidasStatus };
